import { Box } from '@mui/material';
import { SxProps, Theme } from '@mui/system';
import { FC } from 'react';
import { StyledViewerContainer } from './CfDocumentViewer.styles';
import CfDocumentViewerBody from './components/CfDocumentViewerBody';
import CfDocumentViewerHeader from './components/CfDocumentViewerHeader';

export interface CfDocumentViewerProps {
  fileName: string;
  fileSrc: string;
  fileType: string;
  downloadBlob: Blob;
  containerSx?: SxProps<Theme>;
}

export const CfDocumentViewer: FC<CfDocumentViewerProps> = (props: CfDocumentViewerProps) => {
  const { fileName, fileSrc, fileType, containerSx } = props;

  return (
    <StyledViewerContainer sx={{ ...containerSx }}>
      <Box>
        <CfDocumentViewerHeader fileName={fileName} fileSrc={fileSrc} downloadBlob={props.downloadBlob} />
      </Box>
      <Box sx={{ mt: 1 }}>
        <CfDocumentViewerBody fileSrc={fileSrc} fileName={fileName} fileType={fileType} />
      </Box>
    </StyledViewerContainer>
  );
};
